import { useContext } from 'react';

import { HoneycombTooltipMetadataContext } from '../context/honeycomb-tooltip-metadata.context.js';

export const useHoneycombTooltipMetadata = () =>
  useContext(HoneycombTooltipMetadataContext);
